__turbopack_context__.v({
  "content": "style-module-scss-module__aTRFoG__content",
  "wrapper": "style-module-scss-module__aTRFoG__wrapper",
});
